var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeetcode1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2500,
    viewBox: "-.067 -.068 1024.136 1024.068",
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1023.524 511.966c0 163.698 0 327.396.477 491.094 0 17.052-3.888 20.94-20.94 20.872q-491.094-.819-982.188 0c-17.051 0-20.94-3.82-20.871-20.872q.818-491.094-.002-982.188c-.066-17.051 3.82-20.94 20.873-20.871q491.094.818 982.188 0c17.052 0 21.008 3.82 20.94 20.871-.477 163.698-.477 327.396-.477 491.094z",
    fill: "#fefefe"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m454.878 321.736c-61.387 61.386-124.82 121.068-184.774 184.16-44.404 46.722-40.925 113.906 5.593 161.924 55.18 56.68 111.996 111.724 168.063 167.45 21.212 21.963 20.94 47.063 5.388 70.39-14.392 21.485-35.058 34.65-63.092 22.577a132.664 132.664 0 0 1 -35.672-25.578c-51.77-52.315-104.767-103.47-155.99-156.4-89.898-92.83-90.921-232.451-.478-324.668 127.07-129.867 256.05-257.688 384.484-386.054 28.307-28.306 63.843-30.148 87.033-6.002s21.008 55.657-6.411 84.509q-43.176 45.426-86.692 90.443c-30.693 47.609-71.823 84.645-117.453 117.249z",
    fill: "#070706"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m677.029 641.015h-183.614c-40.925 0-70.186-24.76-69.504-58.113.614-32.262 27.966-55.998 68.208-56.135q187.025-.886 374.05 0c39.833 0 62.342 22.031 62.683 56.476 0 35.74-23.055 57.294-64.934 57.704-62.137.545-124.547.068-186.89.068z",
    fill: "#b4b2b1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m386.056 928.1c60.569-7.366 79.053-37.241 57.704-92.967 63.842 33.49 110.837 26.056 162.47-25.577 26.465-26.465 52.52-53.339 79.598-79.19s57.43-26.464 81.44-2.728 23.532 54.566-1.978 81.44c-34.104 35.195-67.457 70.595-103.47 103.266-76.94 69.777-199.917 75.915-275.764 15.756z",
    fill: "#eaa240"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m454.878 321.736a1295.942 1295.942 0 0 1 117.452-117.249c89.693 27.829 142.349 101.152 202.372 164.926 19.575 20.871 11.663 53.747-10.777 72.777a53.338 53.338 0 0 1 -73.87-2.183 821.627 821.627 0 0 1 -74.413-74.278c-44.13-52.315-96.855-66.502-160.765-43.993z",
    fill: "#eaa340"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeetcode1);
export default __webpack_public_path__ + "static/media/leetcode-1.c85b8c77cb91e7879215c403924ec5be.svg";
export { ForwardRef as ReactComponent };